import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { $, $$ } from "./recruit-utils.js";

// 吹き出し設定
const BUBBLE_CONFIGS = [
  {
    imageSelector: '.js-voice-img01',
    bubbleSelector: '.js-voice-img01 .p-recruit-staff-voice__speech-bubble'
  },
  {
    imageSelector: '.js-voice-img03',
    bubbleSelector: '.js-voice-img03 .p-recruit-staff-voice__speech-bubble'
  },
  {
    imageSelector: '.js-voice-img06',
    bubbleSelector: '.js-voice-img06 .p-recruit-staff-voice__speech-bubble'
  }
];

// 画像展開位置設定
const getImagePositions = () => {
  if (window.innerWidth >= 769) {
    return [
      { x: -27.01, y: -15.77 }, { x: 15, y: -8 }, { x: 30.41, y: 1 },
      { x: 25, y: 28 }, { x: 2, y: 22 }, { x: -28.46, y: 17.5 }
    ];
  } else if (window.innerWidth >= 421) {
    return [
      { x: -35.01, y: -24.77 }, { x: 18, y: -16 }, { x: 38.41, y: -3 },
      { x: 33, y: 35 }, { x: -4, y: 25 }, { x: -37.46, y: 20.5 }
    ];
  } else {
    return [
      { x: -36, y: -55 }, { x: 60, y: -40 }, { x: 39, y: 5 },
      { x: 67, y: 105 }, { x: -0, y: 20 }, { x: -40, y: 65 }
    ];
  }
};

export function initStaffVoiceAnimation() {
  const staffSection = $('.p-recruit-staff');
  const images = $$('.p-recruit-staff-voice__image');
  const content = $('.p-recruit-staff-voice__content');

  if (!staffSection || !images.length || !content) return;

  initializeElements(images);

  if (window.innerWidth >= 769) {
    setupHoverEvents(staffSection, images);
  } else {
    setupScrollEvents(staffSection, images);
  }
}

// 初期状態設定
function initializeElements(images) {
  const imagesContainer = $('.p-recruit-staff-voice__images');
  const voiceGood = $('.p-recruit-staff-voice__good');
  const statusElements = $$('.p-recruit-staff-voice__image-status');

  if (imagesContainer) gsap.set(imagesContainer, { zIndex: -1 });
  if (voiceGood) gsap.set(voiceGood, { opacity: 0, scale: 0.8, y: 20 });
  
  statusElements.forEach(status => {
    gsap.set(status, { opacity: 0, scale: 0.8, y: 20 });
  });

  images.forEach((img, index) => {
    const target = img.closest('.p-recruit-staff-voice__image-wrap') || img;
    const hasVoiceBubble = BUBBLE_CONFIGS.some(config => target.closest(config.imageSelector));
    
    const settings = {
      x: 0, y: 0, opacity: 1, scale: 1, clearProps: "transform"
    };
    
    if (hasVoiceBubble) {
      settings.boxShadow = '0 0 54px rgba(255, 255, 255, 0.2)';
    }
    
    gsap.set(target, settings);

    // SP時は最初の画像以外を非表示
    if (window.innerWidth <= 768 && !target.closest('.js-voice-img01')) {
      gsap.set(target, { opacity: 0 });
    }
  });
}

// 画像展開アニメーション
function animateImages(images) {
  const positions = getImagePositions();
  const viewportWidth = Math.min(window.innerWidth, 1500);

  images.forEach((img, index) => {
    const target = img.closest('.p-recruit-staff-voice__image-wrap') || img;
    const pos = positions[index];
    
    const xValue = (pos.x * viewportWidth) / 100;
    const yValue = (pos.y * viewportWidth) / 100;

    gsap.to(target, {
      transform: `translate(-50%, -50%) translate(${xValue}px, ${yValue}px)`,
      duration: 0.8,
      ease: "back.out(1.7)",
      onStart: () => {
        if (window.innerWidth <= 768 && !target.closest('.js-voice-img01')) {
          gsap.set(target, { opacity: 1 });
        }
      },
      onComplete: () => {
        if (index === images.length - 1 && window.innerWidth <= 768) {
          images.forEach(img2 => {
            if (!img2.closest('.js-voice-img01')) {
              gsap.to(img2, { opacity: 1, duration: 0.6 });
            }
          });
        }
      }
    });
  });
}

// PC用ホバーイベント設定
function setupHoverEvents(staffSection, images) {
  const imagesContainer = $('.p-recruit-staff-voice__images');
  let hasInitialized = false;

  ScrollTrigger.create({
    trigger: staffSection,
    start: "top 50%",
    onEnter: () => {
      if (!hasInitialized) {
        hasInitialized = true;
        animateImages(images);
        
        setTimeout(() => {
          showUIElements();
          setTimeout(() => createHoverAreas(imagesContainer), 1000);
        });
      }
    }
  });
}

// スマホ・タブレット用スクロールイベント設定
function setupScrollEvents(staffSection, images) {
  const imagesContainer = $('.p-recruit-staff-voice__images');
  let hasInitialized = false;

  ScrollTrigger.create({
    trigger: staffSection,
    start: "top 50%",
    onEnter: () => {
      if (!hasInitialized) {
        hasInitialized = true;
        animateImages(images);
        
        setTimeout(() => {
          showUIElements();
          setupScrollTriggers(imagesContainer);
        }, 800);
      }
    }
  });
}

// UI要素表示
function showUIElements() {
  const imagesContainer = $('.p-recruit-staff-voice__images');
  const voiceGood = $('.p-recruit-staff-voice__good');
  const statusElements = $$('.p-recruit-staff-voice__image-status');

  hideAllBubbles();
  if (imagesContainer) gsap.set(imagesContainer, { zIndex: -1 });
  
  if (voiceGood) {
    gsap.to(voiceGood, { opacity: 1, scale: 1, y: 0, duration: 0.3, ease: "back.out(1)" });
  }
  
  statusElements.forEach(status => {
    gsap.to(status, { opacity: 1, scale: 1, y: 0, duration: 0.3, ease: "back.out(1)" });
  });
}

// ホバー領域作成
function createHoverAreas(imagesContainer) {
  const staffVoiceContent = $('.p-recruit-staff-voice__content');
  if (!staffVoiceContent) return;

  // 既存のホバー領域削除
  staffVoiceContent.querySelectorAll('.staff-voice-hover-area').forEach(area => area.remove());

  BUBBLE_CONFIGS.forEach((config, index) => {
    const imageWrap = $(config.imageSelector);
    if (!imageWrap) return;

    const imageRect = imageWrap.getBoundingClientRect();
    const contentRect = staffVoiceContent.getBoundingClientRect();
    
    // ホバー領域計算
    const relativeTop = imageRect.top - contentRect.top;
    const imageLeft = imageRect.left - contentRect.left;
    const imageRight = imageRect.right - contentRect.left;
    const contentWidth = contentRect.width;
    
    const leftOverhang = Math.min(0, imageLeft);
    const rightOverhang = Math.max(0, imageRight - contentWidth);
    const hoverLeft = leftOverhang;
    const hoverWidth = contentWidth + Math.abs(leftOverhang) + rightOverhang;

    const hoverArea = document.createElement('div');
    hoverArea.className = `staff-voice-hover-area`;
    hoverArea.style.cssText = `
      position: absolute;
      top: ${relativeTop}px;
      left: ${hoverLeft}px;
      width: ${hoverWidth}px;
      height: ${imageRect.height}px;
      z-index: 50;
      pointer-events: auto;
      background: transparent;
      cursor: pointer;
    `;

    hoverArea.addEventListener('mouseenter', () => {
      if (imagesContainer) gsap.set(imagesContainer, { zIndex: 1 });
      showBubble(config.bubbleSelector);
    });

    hoverArea.addEventListener('mouseleave', () => {
      hideBubble(config.bubbleSelector);
      if (!document.querySelector('.p-recruit-staff-voice__speech-bubble.is-visible') && imagesContainer) {
        gsap.set(imagesContainer, { zIndex: -1 });
      }
    });

    staffVoiceContent.appendChild(hoverArea);
  });
}

// スクロールトリガー設定
function setupScrollTriggers(imagesContainer) {
  BUBBLE_CONFIGS.forEach(config => {
    const imageElement = $(config.imageSelector);
    if (!imageElement) return;

    ScrollTrigger.create({
      trigger: imageElement,
      start: "top center",
      end: "bottom center",
      onEnter: () => {
        if (imagesContainer) gsap.set(imagesContainer, { zIndex: 1 });
        showBubble(config.bubbleSelector);
      },
      onLeave: () => hideBubble(config.bubbleSelector),
      onEnterBack: () => {
        if (imagesContainer) gsap.set(imagesContainer, { zIndex: 1 });
        showBubble(config.bubbleSelector);
      },
      onLeaveBack: () => hideBubble(config.bubbleSelector)
    });
  });
}

// 吹き出し表示
function showBubble(selector) {
  // 他の吹き出しを非表示
  BUBBLE_CONFIGS.forEach(config => {
    if (config.bubbleSelector !== selector) {
      hideBubble(config.bubbleSelector);
    }
  });

  const bubble = $(selector);
  if (bubble) {
    bubble.classList.add('is-visible');
    const imageWrap = bubble.closest('.p-recruit-staff-voice__image-wrap');
    if (imageWrap) {
      gsap.set(imageWrap, { zIndex: 10 });
      gsap.to(imageWrap, {
        boxShadow: '0 0 0px rgba(255, 255, 255, 0)',
        duration: 0.3,
        ease: "power2.out"
      });
    }
  }
}

// 吹き出し非表示
function hideBubble(selector) {
  const bubble = $(selector);
  if (bubble) {
    bubble.classList.remove('is-visible');
    const imageWrap = bubble.closest('.p-recruit-staff-voice__image-wrap');
    if (imageWrap) {
      gsap.to(imageWrap, {
        boxShadow: '0 0 54px rgba(255, 255, 255, 0.2)',
        duration: 0.3,
        ease: "power2.out"
      });
      setTimeout(() => {
        if (!bubble.classList.contains('is-visible')) {
          gsap.set(imageWrap, { zIndex: 'auto' });
        }
      }, 300);
    }
  }
}

// 全吹き出し非表示
function hideAllBubbles() {
  BUBBLE_CONFIGS.forEach(config => hideBubble(config.bubbleSelector));
}